<!-- Migrated from legacy/Plus/Plus/People/index.shtml -->

<template>
  <h4>People</h4>
  <div v-for="group in groups" :key="group.role" class="group">
    <h5>{{ group.role }}</h5>
    <div class="portraits">
      <div v-for="person in group.people" :key="person.name" class="portrait">
        <img :src="person.image" :alt="`Portrait of ${person.name}`" />
        <p>
          <strong>{{ person.name }}</strong><span v-if="person.role">, {{ person.role }}</span>
          <br />{{ person.affiliation }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
const groups = [
  {
    role: "Animators",
    people: [
      {
        name: "Christopher Hammang",
        image: "/Plus/People/Christopher_Hammang.jpg",
        affiliation: "Garvan Institute of Medical Research, Sydney"
      },
      {
        name: "Kate Patterson",
        image: "/Plus/People/Kate_Patterson.png",
        affiliation: "Garvan Institute of Medical Research, Sydney"
      }
    ]
  },
  {
    role: "Animation Gurus & Technical Direction",
    people: [
      {
        name: "Drew Berry",
        image: "/Plus/People/Drew_Berry.jpg",
        affiliation: "Walter and Eliza Hall Institute, Melbourne"
      }
    ]
  },
  {
    role: "Project Management",
    people: [
      {
        name: "Sean O'Donoghue",
        role: "Project Leader",
        image: "/Plus/People/Sean_ODonoghue.png",
        affiliation: "CSIRO & Garvan Institute, Sydney"
      },
      {
        name: "Benedetta Frida Baldi",
        image: "/Plus/People/Benedetta_Frida_Baldi.png",
        affiliation: "Garvan Institute, Sydney"
      },
      {
        name: "Deborah Szapiro",
        image: "/Plus/People/DebSzapiro_headshot.png",
        affiliation: "University of Technology Sydney"
      }
    ]
  }
];
</script>

<style scoped>
h5 {
  font-weight: 600;
  font-size: 0.95rem;
  margin: 1.5rem 0 0.5rem;
}
.portraits {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 3%;
}
.portrait {
  width: 28%;
  min-width: 180px;
}
.portrait img {
  max-height: 275px;
  max-width: 100%;
  border-radius: 4px;
}
.portrait p {
  font-size: 0.9rem;
}
</style>
